import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaEllipsisH } from "react-icons/fa";
import { toast } from "react-toastify";
import { CLIENT } from "../../Router/paths";
import { axiosInstance } from "../../config/https";
import { useLoader, useModal } from "../../context/LoaderContext";

export default function ClientHome() {
  const { startLoader, stopLoader } = useLoader();
  const [jobs, setJobs] = useState([]);
  const { openModal } = useModal();

  useEffect(() => {
    getJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getJobs = () => {
    startLoader();
    axiosInstance
      .get("/api/jobposts/?user_jobs=true")
      .then((resp) => {
        stopLoader();
        if (resp.status === 200 || resp.status === 201) {
          const Data = resp.data;
          setJobs(Data.data);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const handleStripe = (job) => {
    if (job.payment !== null) {
      pay(job.id);
    } else {
      startLoader();
      axiosInstance
        .post("/api/transaction/", { job: job.id })
        .then((resp) => {
          stopLoader();
          if (resp.status === 200 || resp.status === 201) {
            pay(job.id);
          }
        })
        .catch(() => {
          stopLoader();
        });
    }
  };

  const pay = (jobId) => {
    openModal(
      "card", //gif url
      "Card Credentials!", //title
      "Enter your card information below to proceed with the secure payment process." //subtitle
    );
    startLoader();
    axiosInstance
      .post("/api/create-checkout-session/", { job_id: jobId })
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          setTimeout(() => {
            window.open(Data.url, "_blank");
          }, 2000);
        } else {
          toast.error("something went wrong");
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const completeJob = (id) => {
    startLoader();
    axiosInstance
      .put(`/api/jobposts/${id}/complete/`)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          openModal(
            "completeJob", //gif url
            "Job Completed Successfully", //title
            "Congratulations! Your job has been completed. Thank you for using our services." //subtitle
          );
          getJobs();
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  return (
    <>
      <section className="client-head pc-p-2">
        <div className="container-fluid px-5">
          <div className="row">
            <div className="col-lg-6">
              <div className="primary-heading color-dark">
                <div className="d-flex align-items-center">
                  <h4 className="color-secondary mr-3">Your Workplace</h4>
                  <Link to={CLIENT.jobPost} className=" primary-bg primary-btn">
                    View all Jobs
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="d-flex justify-content-end">
                <Link
                  to={CLIENT.jobDetails}
                  className="primary-btn secondary-bg"
                >
                  Post Job
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="client-head-boxes">
        <div className="container-fluid px-5">
          <div className="row">
            {jobs?.map((e, i) => (
              <div className="col-lg-3 col-md-3 col-12" key={i}>
                <div className="client-head-box mb-3">
                  <h4>{e?.job_title}</h4>
                  {e?.freelancer === null ? (
                    <p className="tag-orange">Hiring</p>
                  ) : e.status === "completed" ? (
                    <p>Completed</p>
                  ) : (
                    <p>Hired</p>
                  )}
                  <p className="text-muted" style={{ textAlign: "justify" }}>
                    {e?.description}
                  </p>
                  <p>You have {e?.numofproposals} new Proposals. </p>
                  <Link
                    to={CLIENT.reviewProposals(e.id)}
                    className="primary-btn secondary-bg w-100 d-flex justify-content-center align-items-center"
                    style={{ gap: "1rem" }}
                  >
                    Review Proposals{" "}
                    <i>
                      <FaEllipsisH />
                    </i>
                  </Link>
                  {e?.freelancer && (
                    <>
                      <Link
                        className="primary-btn color-light mt-3 p-2 w-100"
                        onClick={() => handleStripe(e)}
                      >
                        Pay with Stripe
                      </Link>
                      <Link
                        to={CLIENT.fileAComplain(e.id)}
                        className="primary-btn secondary-bg mt-3 w-100 d-flex justify-content-center align-items-center"
                        style={{ gap: "1rem" }}
                      >
                        Dispute
                      </Link>
                      {e.status === "pending" && (
                        <a
                          className="primary-btn secondary-bg mt-3 w-100 d-flex justify-content-center align-items-center"
                          style={{ gap: "1rem" }}
                          onClick={() => completeJob(e.id)}
                        >
                          Complete Job
                        </a>
                      )}
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="container-fluid px-5 mt-5">
        <section className="started-box p-5">
          <div className="primary-heading color-dark">
            <h3 className="mb-4 color-secondary">
              Some Key Features Of BNR-360 to facilitate our client.
            </h3>
          </div>
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-6">
              <div className="primary-heading color-dark">
                <h5 className="mb-3"> Key Features: </h5>
                <h6 className="mt-2"> Post a Job: </h6>
                <ul className="mb-3">
                  <li>
                    Easy-to-fill job posting forms with detailed project
                    descriptions.
                  </li>
                  <li>Option to attach files or reference materials.</li>
                </ul>
                <h6> Proposal Review:</h6>
                <ul className="mb-3">
                  <li>Tools to review and compare freelancer proposals.</li>
                  <li>
                    Access to freelancer profiles, ratings, and previous work.
                  </li>
                </ul>
                <h6> Communication Tools:</h6>
                <ul className="mb-3">
                  <li>Messaging system to communicate with freelancers.</li>
                  <li>Notifications for new proposals and messages.</li>
                </ul>
                <h6> Feedback and Ratings:</h6>
                <ul className="mb-3">
                  <li>
                    {" "}
                    Ability to leave feedback and ratings for freelancers.
                  </li>
                  <li>
                    {" "}
                    Publicly visible ratings to help freelancers build
                    credibility.
                  </li>
                </ul>
                <h6> Dispute Resolution:</h6>
                <ul className="mb-3">
                  <li> Clear process for dispute resolution.</li>
                  <li> Mediation services to address conflicts.</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              {/* <div className="primary-heading color-dark">
                                          
                  <h5 className="mb-3"> General Platform Features: </h5>

                  <h6> Security: </h6>

                  <ul className="mb-3">
                      <li> SSL encryption for secure transactions.</li>
                      <li> Two-factor authentication for user accounts.</li>
                  </ul>
                  <h6> Mobile Responsiveness: </h6>

                  <ul className="mb-3">
                      <li> Ensure the platform is accessible and user-friendly on mobile devices.</li>
                  </ul>
                  <h6> Notifications: </h6>

                  <ul className="mb-3">
                      <li> Real-time notifications for job updates, messages, and milestones.</li>
                  </ul>
                  <h6> Terms of Service and Policies: </h6>

                  <ul className="mb-3">
                      <li> Clearly defined terms of service, privacy policy, and user guidelines.</li>
                  </ul>
                  <h6> Search Engine Optimization (SEO): </h6>

                  <ul className="mb-3">
                      <li> Optimize the platform for search engines to attract organic traffic.</li>
                  </ul>
                  <h6> Analytics: </h6>

                  <ul className="mb-3">
                      <li> Implement analytics tools to track user behavior and platform performance.</li>
                  </ul>
              </div> */}
              <div className="side-img">
                <img src="/assets/sharing-img.jpg" alt="Sharing" />
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className="client-pay-boxes mt-5 mb-5">
        <div className="container-fluid px-5">
          <div className="row">
            <div className="col-lg-4">
              <div className="client-paybox">
                <div className="row align-items-center">
                  <div className="col-lg-8">
                    <div className="primary-heading color-dark">
                      <h4>Step 1</h4>
                      <p>How to set up your preferred billing method</p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="client-imgbox">
                      <img src="/assets/pay-box1.png" alt="Pay Box" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="client-paybox">
                <div className="row align-items-center">
                  <div className="col-lg-8">
                    <div className="primary-heading color-dark">
                      <h4>Step 2</h4>
                      <p>How to set up your preferred billing method</p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="client-imgbox">
                      <img src="/assets/pay-box2.png" alt="Pay Box" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="client-paybox">
                <div className="row align-items-center">
                  <div className="col-lg-8">
                    <div className="primary-heading color-dark">
                      <h4>Step 3</h4>
                      <p>How to set up your preferred billing method</p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="client-imgbox">
                      <img src="/assets/pay-box3.png" alt="Pay Box" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
